<div *ngIf="votingControl.voting" class="m-0 my-1">
  <div *ngIf="votingControl.voting.isClosed" class="voting-closed-info card-shadow">
    <span class="material-icons warning-icon">error_outline</span>
    <div class="content">
      <span [innerHTML]="votingControl.voting.description.closed"></span>
    </div>
  </div>
  <app-tab-group *ngIf="!votingControl.insufficientVotesMode"
                 class="section-tabs"
                 [sendPageViewOnTabChange]="true">
    <ng-container *ngFor="let section of votingControl.voting.sections">
      <app-tab [title]="section.title">
        <app-voting-section appAccordion class="voting-section"
                            [title]="section.title"
                            [icon]="section.symbol"
                            [items]="section.items"
                            [selectionLimit]="section.settings.selection_limits">
        </app-voting-section>
      </app-tab>
    </ng-container>
  </app-tab-group>
</div>
<app-voting-navigation></app-voting-navigation>

<div *ngIf="!votingControl.voting && !votingControl.voteFailed" class="loading-indicator">
  <mat-spinner strokeWidth="2" color="primary" diameter="54"></mat-spinner>
  <h4>Voting wird geladen...</h4>
</div>
